



















import { Component, Vue } from "vue-property-decorator";
import headerTitle from "@/components/headerTitle.vue";
import imageModalCom from "./imageModalCom.vue";
import { imageContrast } from "@/req/ReturnsManage";

@Component({
  components: { headerTitle, imageModalCom },
})
export default class Home extends Vue {
  public loading = true
  public tableColumns = [
    {
      title: "卖家账号",
      key: "seller_username",
      align: "center",
    },
    {
      title: "买家账号",
      key: "purchaser_username",
      align: "center",
    },
    {
      title: "商品编号",
      key: "commodity_id",
      align: "center",
    },
    {
      title: "商品类型",
      key: "commodity_type",
      align: "center",
      slot: "commodity_type",
    },
    {
      title: "角色名称",
      key: "commodity_title",
      align: "center",
    },
    {
      title: "所属游戏/区服",
      key: "game_name",
      align: "center",
      slot: "game_name",
    },
    {
      title: "价格",
      key: "total_amount",
      align: "center",
    },
    {
      title: "上架时间",
      key: "shelf_time",
      align: "center",
    },
    {
      title: "退款理由",
      key: "refuse_reason",
      align: "center",
    },
    {
      title: "购买时间",
      key: "pay_time",
      align: "center",
    },
    {
      title: "拒绝时间",
      key: "refuse_time",
      align: "center",
    },
    {
      title: "截图对比",
      key: "commodity_yesterday_account",
      align: "center",
      slot: "commodity_yesterday_account",
    },
  ];
  public tableData = [];
  public show(list) {
    this.tableData = list;
    this.loading = false
  }
  public async showModal(row) {
    const obj = {
      token: this.$fn.cookies.getToken("token"),
      commodity_id: row.commodity_id,
      order_id: row.id,
    };
    const res = await imageContrast(obj);
    if (res.code == 0) {
      const $imageModalCom: any = this.$refs.imageModalCom;
      $imageModalCom.show(res.data, row.commodity_id);
    }
  }

}
